export default function generalReducer(state = { ...defaultState }, action) {
  let newState = { ...state }
  switch (action.type) {
    case 'RESET_GENERAL': {
      return { ...defaultState }
    }
    case 'SET_SELECTED_TYPE': {
      const { selectedType, canProceed } = action.payload
      newState.type = selectedType
      if (canProceed) {
        newState.canProceedToNextStep = canProceed
      }
      return newState
    }
    case 'SET_SELECTED_SHAPE': {
      const { selectedShape, canProceed } = action.payload
      newState.shape = selectedShape
      if (canProceed !== null) {
        newState.canProceedToNextStep = canProceed
      }
      return newState
    }
    case 'SET_ADDITIONAL_SELECTED_SHAPE': {
      const { selectedShape } = action.payload
      newState.additionalShape = selectedShape
      return newState
    }
    case 'SET_SELECTED_SET': {
      const { selectedSet, canProceed } = action.payload
      newState.set = selectedSet
      if (canProceed !== null) {
        newState.canProceedToNextStep = canProceed
      }
      return newState
    }
    case 'SET_SELECTED_FASTENER': {
      const { selectedFastener, canProceed } = action.payload
      newState.fasteners = selectedFastener
      if (canProceed !== null) {
        newState.canProceedToNextStep = canProceed
      }
      return newState
    }
    case 'SET_SELECTED_STYLE': {
      const { selectedStyle } = action.payload
      newState.style = selectedStyle
      return newState
    }
    case 'SET_SELECTED_FILLING': {
      const { selectedFilling } = action.payload
      newState.filling = selectedFilling
      newState.canProceedToNextStep = true
      return newState
    }
    case 'SET_ADDITIONAL_FILLING_OPTION': {
      const { selectedFilling } = action.payload
      newState.additionalFillingOptions = selectedFilling
      return newState
    }
    case 'SET_SELECTED_FABRIC': {
      const { selectedFabric, canProceed } = action.payload
      newState.fabric = selectedFabric
      if (canProceed !== null) {
        newState.canProceedToNextStep = canProceed
      }
      return newState
    }
    case 'SET_SINGLE_FABRIC': {
      const { selectedFabric } = action.payload
      newState.singleFabric = selectedFabric
      return newState
    }
    case 'SET_FABRIC_DIRECTION': {
      const { fabricDirection } = action.payload
      newState.fabricDirection = fabricDirection
      return newState
    }
    case 'SET_SELECTED_CORD_FABRIC': {
      const { selectedFabric, canProceed } = action.payload
      newState.cordFabric = selectedFabric
      if (canProceed !== null) {
        newState.canProceedToNextStep = canProceed
      }
      return newState
    }
    case 'SET_SINGLE_CORD_FABRIC': {
      const { selectedFabric } = action.payload
      newState.singleCordFabric = selectedFabric
      return newState
    }
    case 'SET_CORD_FABRIC_DIRECTION': {
      const { fabricDirection } = action.payload
      newState.cordFabricDirection = fabricDirection
      return newState
    }
    case 'SET_SELECTED_DIMENSIONS': {
      const { selectedDimensions } = action.payload
      newState.dimensions = selectedDimensions
      return newState
    }
    case 'SET_ZIPPER_ORIENTATION': {
      const { zipperOrientation } = action.payload
      newState.zipperOrientation = zipperOrientation
      return newState
    }
    case 'SET_CAN_PROCEED_TO_NEXT_STEP': {
      const { canProceed } = action.payload
      newState.canProceedToNextStep = canProceed
      return newState
    }
    case 'SET_FASTENER_PLACEMENT': {
      const { fastenerPlacement } = action.payload
      newState.fastenerPlacement = fastenerPlacement
      return newState
    }
    case 'ADD_TO_CART': {
      newState.addingToCart = true
      return newState
    }
    case 'ADD_TO_CART_FAILED': {
      newState.addingToCart = false
      newState.addToCartFailed = true
      return newState
    }
    case 'ADD_TO_CART_SUCCESS': {
      newState.addingToCart = false
      newState.addToCartFailed = false
      return newState
    }
    case 'SET_ALL_FABRICS': {
      const { allFabrics } = action.payload
      newState.allFabrics = allFabrics
      return newState
    }
    case 'SET_BEEN_THROUGH': {
      const { beenThrough } = action.payload
      newState.beenThrough = beenThrough
      return newState
    }
    case 'SET_ADDED_TO_CART_MESSAGE': {
      const { fabricId } = action.payload
      newState.addedToCartMessages = {
        ...newState.addedToCartMessages,
        [fabricId]: !newState.addedToCartMessages[fabricId],
      }
      return newState
    }
    case 'SET_CATEGORY': {
      const { category } = action.payload
      newState.category = category
      return newState
    }
    case 'SET_CUSTOM_TEMPLATE_TUTORIAL_VISIBLE': {
      newState.customTemplateTutorialVisible = !newState.customTemplateTutorialVisible
      return newState
    }
    case 'SET_CORDING_MODAL_VISIBLE': {
      newState.cordingModalVisible = !newState.cordingModalVisible
      return newState
    }
    case 'SET_ACCEPTED_CORDING_WARNING': {
      newState.acceptedCordingWarning = !newState.acceptedCordingWarning
      return newState
    }
    case 'SET_CORDING_MODAL_VISIBLE_VALUE': {
      const { cordingModalVisible } = action.payload
      newState.cordingModalVisible = cordingModalVisible
      return newState
    }
    case 'SET_INDIVIDUAL_ROUNDED_BACK': {
      const { individualRoundedBack } = action.payload
      newState.individualRoundedBack = individualRoundedBack
      return newState
    }
    case 'SET_INDIVIDUAL_ROUNDED_SEAT': {
      const { individualRoundedSeat } = action.payload
      newState.individualRoundedSeat = individualRoundedSeat
      return newState
    }
    case 'SET_USER': {
      const { user } = action.payload
      newState.user = user
      return newState
    }
    case 'SET_KITS': {
      const { kits } = action.payload
      newState.kits = kits
      return newState
    }
    case 'SET_TOTAL_PRICE': {
      const { totalPrice } = action.payload
      newState.totalPrice = totalPrice
      return newState
    }
    case 'ADD_TO_CART_YARDS': {
      newState.addingToCartYards = true
      return newState
    }
    case 'ADD_TO_CART_YARDS_SUCCESS': {
      newState.addingToCartYards = false
      newState.addToCartYardsFailed = false
      return newState
    }
    case 'ADD_TO_CART_YARDS_FAILED': {
      newState.addingToCartYards = false
      newState.addToCartYardsFailed = true
      return newState
    }
    case 'SET_ADDED_TO_CART_MESSAGE_YARDS': {
      const { fabricId } = action.payload
      newState.addedToCartMessagesYards = {
        ...newState.addedToCartMessagesYards,
        [fabricId]: !newState.addedToCartMessagesYards[fabricId],
      }
      return newState
    }
    case 'SET_REMOVE_ITEM': {
      const { removeItem } = action.payload
      newState.removeItem = removeItem
      return newState
    }
    case 'SET_ENABLE_SCROLL_TO': {
      const { enableScrollTo } = action.payload
      newState.enableScrollTo = enableScrollTo
      return newState
    }
    case 'SET_PRODUCT_QTY': {
      const { productQty } = action.payload
      newState.productQty = productQty
      return newState
    }
    case 'SET_IS_CONNECTED': {
      const { isConnected } = action.payload
      newState.isConnected = isConnected
      return newState
    }
    case 'SET_CUSTOM_TAMPLATE_NO_OF_FASTENERS': {
      const { noOfFasteners } = action.payload
      newState.noOfFasteners = noOfFasteners
      return newState
    }
    case 'SET_SCROLL_POSITION':
      return {
        ...state,
        scrollPosition: action.payload,
      }
    default:
      return newState
  }
}

const defaultState = {
  user: null,
  type: null,
  shape: null,
  dimensions: {},
  zipperOrientation: null,
  additionalShape: null,
  set: null,
  fasteners: null,
  fastenerPlacement: {
    checkboxes: [0, 0, 0, 0, 0],
    mirroredCheckboxes: [0, 0, 0, 0, 0],
  },
  style: null,
  filling: null,
  additionalFillingOptions: {},
  fabric: null,
  fabricDirection: null,
  cordFabric: null,
  cordFabricDirection: null,
  canProceedToNextStep: false,
  addingToCart: false,
  addToCartFailed: false,
  addedToCartMessages: {},
  addingToCartYards: false,
  addToCartYardsFailed: false,
  addedToCartMessagesYards: {},
  beenThrough: {
    fabrics: false,
    style: false,
  },
  category: null,
  customTemplateTutorialVisible: false,
  cordingModalVisible: false,
  acceptedCordingWarning: false,
  individualRoundedBack: false,
  individualRoundedSeat: false,
  kits: null,
  totalPrice: null,
  removeItem: null,
  enableScrollTo: null,
  productQty: 1,
  isConnected: false,
  noOfFasteners: null,
  scrollPosition: 0,
}
